export default __webpack_public_path__ + "static/media/drug-icon.b5cde18e.svg";